import WGTeamAssessment from './WGTeamAssessment';

export default WGTeamAssessment;
